import {all} from "redux-saga/effects";
import {combineReducers} from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { dptoSlice } from "../app/modules/Comun/Departamento/_redux/dptoSlice";
import { localidadSlice } from "../app/modules/Comun/Localidad/_redux/localidadSlice";
import { establecimientoSlice } from "../app/modules/Inscripciones/preInscripcion/_redux/establecimiento/establecimientoSlice";
// import {customersSlice} from "../app/modules/ECommerce/_redux/customers/customersSlice";
// import {productsSlice} from "../app/modules/ECommerce/_redux/products/productsSlice";
// import {remarksSlice} from "../app/modules/ECommerce/_redux/remarks/remarksSlice";
// import {specificationsSlice} from "../app/modules/ECommerce/_redux/specifications/specificationsSlice";

//RUTA API VERSION
import { apiVersionSlice } from '../components/versionsCheck/_redux/apiVersionSlice'

//RUTAS INSCRIPCIONES
import { llamadoSlice } from '../app/modules/Inscripciones/preInscripcion/_redux/inscripcion/llamadoSlice';
import { inscripcionSlice } from '../app/modules/Inscripciones/preInscripcion/_redux/inscripcion/inscripcionSlice';
import { aspiranteSlice } from '../app/modules/Inscripciones/preInscripcion/_redux/aspirante/aspiranteSlice';
import { pasoUnoSlice } from '../app/modules/Inscripciones/preInscripcion/_redux/pasoUno/pasoUnoSclice';
import { pasoDosSlice } from '../app/modules/Inscripciones/preInscripcion/_redux/pasoDos/pasoDosSlice';
import { pasoTresSlice } from '../app/modules/Inscripciones/preInscripcion/_redux/pasoTres/pasoTresSlice';
import { pasoCuatroSlice } from '../app/modules/Inscripciones/preInscripcion/_redux/pasoCuatro/pasoCuatroSlice';
import { pasoCincoSlice } from '../app/modules/Inscripciones/preInscripcion/_redux/pasoCinco/pasoCincoSlice';

//ACCESO PUBLICO PARA OBTENER LA INFORMACION DE LA INSCRIPCION
import { detalleInscripcionSlice } from '../app/modules/Public/Inscripciones/_redux/DetalleInscripcion/DetalleInscripcionSlice';

export const rootReducer = combineReducers({
  auth: auth.reducer,
  departamento: dptoSlice.reducer,
  localidad: localidadSlice.reducer,
  establecimiento: establecimientoSlice.reducer,
  //customers: customersSlice.reducer,
  //products: productsSlice.reducer,
  //remarks: remarksSlice.reducer,
  //specifications: specificationsSlice.reducer,

  //API VERSION
  apiVersion: apiVersionSlice.reducer,

  //LLAMADOS
  llamado: llamadoSlice.reducer,

  //INSCRIPCIONES
  inscripcion: inscripcionSlice.reducer,
  aspirante: aspiranteSlice.reducer,
  pasoUno: pasoUnoSlice.reducer,
  pasoDos: pasoDosSlice.reducer,
  pasoTres: pasoTresSlice.reducer,
  pasoCuatro: pasoCuatroSlice.reducer,
  pasoCinco: pasoCincoSlice.reducer,

  //ACCESO PUBLICO
  detalleInscripcion:detalleInscripcionSlice.reducer
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
